import ArrowUpRight from '@/public/images/blog/arrow-up-right.svg'
import Link from 'next/link'
import dayjs from 'dayjs'
import { useRouter } from 'next/router'
import { useMemo } from 'react'
import { useTranslation } from 'next-i18next'
import { decode } from 'html-entities'

export default function CardBlog({ blog }) {
  const router = useRouter()
  const { t } = useTranslation('blog')

  const categories = t('categories', { returnObjects: true })

  var localizedFormat = require('dayjs/plugin/localizedFormat')
  dayjs.extend(localizedFormat)
  const formatDate = (value) => {
    return router.locale === 'en'
      ? dayjs(value).format('LL').replace(',', '')
      : dayjs(value).format('DD/MM/YYYY')
  }
  const blogCategories = useMemo(() => {
    if (categories && categories?.length) {
      const _blogCategories = blog.categories.map((c) => c.toString())
      return categories.filter((item) => _blogCategories.includes(item.id))
    }
    return []
  }, [categories, blog])

  return (
    <article>
      <div className="w-full aspect-video rounded-2xl overflow-hidden mb-5 border border-solid border-[#E4E7EC]">
        <img
          src={blog?.featured_image || ''}
          alt={decode(blog?.title?.rendered) || ''}
          className="w-full h-full object-cover"
        />
      </div>
      <div className="flex items-center flex-wrap gap-1 mb-2">
        {blogCategories && blogCategories.length
          ? blogCategories.map((item) => (
              <span
                key={item.id}
                className="rounded-full inline-block px-[10px] py-[2px] bg-[#F9FAFB] border border-solid border-[#E4E7EC] text-[14px] leading-5 font-medium text-[#344054]"
              >
                {item.label}
              </span>
            ))
          : null}
      </div>
      <div className="flex items-center gap-4 mb-6">
        <Link href={`/blog/${blog.slug}`}>
          <h4 className="hover:underline lg:text-display-xs text-lg font-semibold text-[#101828] line-clamp-2">
            {decode(blog?.title?.rendered) || ''}
          </h4>
        </Link>
        <ArrowUpRight className="w-5 flex-shrink-0" />
      </div>
      <div className="flex items-center gap-3">
        <div className="flex items-center gap-1">
          <img
            className="w-10 h-10 rounded-full"
            src={
              blog?.user?.avatar_urls[48] ||
              blog?.user?.avatar_urls[24] ||
              blog?.user?.avatar_urls[96] ||
              ''
            }
            alt="Author's avatar"
          />
        </div>
        <div className="flex flex-col text-[14px] leading-5">
          <span className="text-[#101828] font-semibold">
            {blog?.user?.name ? `@${blog?.user?.name}` : ''}
          </span>
          <span className="text-[#475467]">{formatDate(blog.date)}</span>
        </div>
      </div>
    </article>
  )
}
